<template>
    <CRUDCriteria :showReset="true" :showSearch="false" :showAdditionalActions="true">
        <template v-slot:criteriaRows>
            <v-row class="row">
                <v-col cols="3">
                    <v-text-field
                        class="input-text-size"
                        v-model="criteriaState.wildCardSearch"
                        v-uppercase=globalSettingItem.conEverythingToCaps
                        @change="handleChange"
                        >
                        <template v-slot:label>
                            <label>Wildcard (Addition Code, Description)</label>
                        </template>
                    </v-text-field>
                </v-col>
            </v-row>
        </template>
        <template v-slot:additionalActions>
            <v-col cols="2" class="pt-0">
                <v-btn color="primary" rounded dense small @click="printAdditionReport">
                    Print Addit List
                </v-btn>
            </v-col>
        </template>
    </CRUDCriteria>
</template>

<script>
import { mapGetters, mapActions, mapState } from 'vuex';
import CRUDCriteria from '../../common/base/crud-2.0/CRUDCriteria.vue';
import '../../../assets/style.css';
import { generateQueryString } from '../../common/base/report/report-util';
import { clients } from '../../../util/clients';
import GlobalToCaps from '../../../util/shared/GlobalToCaps.mixin.vue';

const { backendRest } = clients.direct;
export default {
  mixins: [GlobalToCaps],
  components: {
    CRUDCriteria,
  },
  props: {
    baseCrudKey: {
      type: String,
      default: 'taxAddition',
    },
  },
  computed: {
    ...mapGetters('base/crud', ['criteria']),
    ...mapState({
      globalSettingItem: (state) => state.SystemConfig.globalSettingItem,
    }),
    criteriaState: {
      get() {
        return this.criteria(this.baseCrudKey);
      },
      set(value) {
        this.setCriteria([this.baseCrudKey, value]);
      },
    },

  },
  methods: {
    ...mapActions(['reAuth', 'flashError']),
    ...mapActions('shared/TaxAdditions', [
      'loadTaxAdditionsRecords',
    ]),
    handleChange() {
      const { baseCrudKey } = this;
      const criteria = {
        ...this.criteriaState,
      };
      this.loadTaxAdditionsRecords({ criteria, baseCrudKey });
    },
    async printAdditionReport() {
      const { jwt } = await this.reAuth();
      let sortBy = 'additionCode';
      let direction = 'asc';

      if ((this.criteriaState || {}).sortBy.length) {
        sortBy = this.criteriaState.sortBy[0].column;
        direction = this.criteriaState.sortBy[0].direction;
      }
      const params = [
        `token=${jwt}`,
        `sortBy=${sortBy || ''}`,
        `direction=${direction || ''}`,
      ];
      const queryString = generateQueryString(params);
      const url = `${backendRest.defaults.baseURL}/shared/addition-report${queryString}`;
      window.open(url, '_blank');
    },
  },
};
</script>
